import { useState } from "react";
import { AnimatedCounter } from "react-animated-counter";

export default function BuyFlow({
  value,
  setValue,
  price,
  handleBuy,
  ticoBalance,
  TICO_USDT,
}) {
  // const localPrice = price.toLocaleString("en-US");
  const USD = TICO_USDT;

  const handleMinus = () => {
    setValue(-1);
  };

  const handlePlus = () => {
    setValue(+1);
  };

  return (
    <>
      <div className="wrapper-buy w-full">
        <div className="price kanit-bold df fd-c ai-c">
          <p>PRICE*: </p>
          <div className="tick text-center">
            {`${price.toLocaleString("en-US")} $TICO`}
            {/* <AnimatedCounter
              value={price}
              color="white"
              fontSize="32px"
              decimalPrecision={0}
              decrementColor={"#ffffff"}
              incrementColor={"#ffffff"}
              includeCommas
            />{" "} */}
          </div>
          <p>(~${USD < 1 ? USD.toFixed(1) : USD.toFixed()})</p>
        </div>

        <div className="wrapper-buy-count">
          <div className="count">
            <button
              className="cta minus"
              onClick={handleMinus}
              disabled={value === 1}
            >
              <span className="m"></span>
            </button>
            <div className="value kanit-bold">{value}</div>
            <button
              className="cta plus"
              onClick={handlePlus}
              disabled={(value + 1) * price > ticoBalance}
            >
              <span className="m"></span>
              <span className="p"></span>
            </button>
          </div>
        </div>

        <button
          className="def btn-buy pr as-c type-40 br-16 fixel_16_bl"
          disabled={ticoBalance < price}
          onClick={handleBuy}
        >
          BUY NOW
        </button>
        <p className="explainer ">*$TICO price might be subject to change based on the market's volatility</p>
      </div>
    </>
  );
}
